import { ChangeDetectionStrategy, Component, computed, contentChild, ElementRef, Input, input } from '@angular/core';
import { TableColumn } from '../../../models/table-column.model';
import { NgClass } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'cosmos-row',
  templateUrl: './row.component.html',
  styleUrls: ['./row.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgClass, MatIcon, MatTooltip, TranslatePipe]
})
export class RowComponent<T extends { id?: string }> {
  item = input<T>();
  readonly columns = input<TableColumn[]>(undefined);
  readonly missingValueMessageKey = input('general.unknown-value');
  readonly missingValueIcon = input('help');
  @Input() showDetails = false;

  details = contentChild<ElementRef>('details');

  hasDetails = computed(() => !!this.details());

  public toggleDetails(): void {
    if (this.hasDetails()) {
      this.showDetails = !this.showDetails;
    }
  }
}
